import { FETCH_HELPLINES_SUCCESS_ACTION } from "./action";

const initialState = {
  processing: false,
  error: false
};

export default function(state: any = initialState, action: Function) {
  switch (action.type) {
    case FETCH_HELPLINES_SUCCESS_ACTION:
      return {
        ...state,
        HelplineList: action.payload.rows,
        HelplineCount: action.payload.count
      };

    default:
      return {
        ...state
      };
  }
}
